module.exports = __webpack_public_path__ + "static/media/collaborationSpain.abc708af.png";